<template>
  <div class="match">
    <div class="talents">
      共匹配到<span class="total">{{ total }}</span
      >条人才信息
    </div>
    <table-info
      :tableInfo="matchTable"
      :total="total"
      :queryInfo="queryInfo"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
      <template #controlBtn="slotProps">
        <div class="btn-control">
          <icon-and-button
            title="发起聊天"
            icon="icon-jr-icon-tidings"
            @handleControl="handleControl"
          />
          <icon-and-button
            title="添加到沟通列表"
            icon="icon-jr-icon-people"
            :extraInfo="{ personCode: slotProps.childInfo.personCode }"
            @handleControl="handleControl"
          />
          <icon-and-button
            title="查看详情"
            icon=""
            :buttonStyle="{ color: '#17757A' }"
            :extraInfo="{ personCode: slotProps.childInfo.personCode }"
            @handleControl="handleControl"
          />
        </div>
      </template>
    </table-info>
  </div>
</template>

<script>
import { getPeoplePost, addToCommunication } from '@/api/projectCenter'
import IconAndButton from '@/components/IconAndButton.vue'
import tableInfo from '../cpns/tableInfo.vue'

export default {
  props: {
    positionType: {
      type: String
    },
    id: {
      type: Number
    },
    tabName: {
      type: String
    },
    searchInfo: {
      type: Object
    }
  },

  components: {
    IconAndButton,
    tableInfo
  },

  data() {
    return {
      queryInfo: {
        baseParam: {
          pageNum: 1, //页数
          pageSize: 30 //大小
        }
      },
      matchTable: [],
      total: 0 // 条数
    }
  },

  watch: {
    tabName: {
      handler: function (newVal) {
        if (newVal === 'first') {
          if (Object.keys(this.$store.state.projectCenter.matchQueryInfo).length) {
            Object.keys(this.$store.state.projectCenter.matchQueryInfo).forEach((item) => {
              this.queryInfo[item] = this.$store.state.projectCenter.matchQueryInfo[item]
            })
          }
          this.search()
        }
      },
      immediate: true
    }
  },

  methods: {
    async search() {
      const params = {
        ...this.queryInfo,
        personType: this.positionType
      }
      const { data: res } = await getPeoplePost(params)

      if (res.resultCode === 200) {
        this.matchTable = res.data.content
        this.total = res.data.totalElements
        this.matchTable.forEach((item) => {
          if (item.personExperience) {
            // this.clientTableData[index].personExperience =
            item.personExperience.reverse()
          }
        })
      }
    },
    handleControl(val, info) {
      if (val === '添加到沟通列表') {
        this.$confirm('确定添加到沟通列表吗?', '提示')
          .then(async () => {
            const { data: res } = await addToCommunication({
              personCode: info.personCode,
              projectId: this.id
            })

            if (res.resultCode === 200) {
              this.$message.success('添加成功')
              this.search()
            }
          })
          .catch(() => {})
      } else if (val === '查看详情') {
        this.$router.push({
          name: 'TalentMessageView',
          query: {
            id: info.personCode,
            clientType: 1,
            chidrenQueryInfo: JSON.stringify(this.queryInfo),
            positionType: this.positionType,
            projectId: this.id,
            tabName: this.tabName,
            searchInfo: JSON.stringify(this.searchInfo)
          }
        })
      }
    },
    handleCurrentChange(newPage) {
      this.queryInfo.baseParam.pageNum = newPage

      this.search()
    },
    handleSizeChange(newSize) {
      this.queryInfo.baseParam.pageSize = newSize

      this.search()
    }
  }
}
</script>

<style lang="less" scoped>
.match {
  .talents {
    font-size: 14px;
    color: #333333;
    margin-bottom: 15px;
    .total {
      color: #ffb847;
      padding: 0 3px;
    }
  }
}
</style>
